import React from 'react'
import { withStyles, Grid, Typography } from '@material-ui/core'
import caveman from '../images/caveman.png'
import MenuBar from '../components/header/MenuBar'
import Footer from '../components/Footer'
import FlashMessage from 'components/FlashMessage'

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  pageNotFound: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // 64px is header height, 226px if footer height
    minHeight: 'calc(100vh - (64px + 226px))',
    [theme.breakpoints.down('sm')]: {
      padding: '20px',
    },
    '& img': {
      marginRight: '40px',
      [theme.breakpoints.down('sm')]: {
        width: '140px',
        marginRight: '20px',
      },
    },
    '& errorMessage': {
      maxWidth: '260px',
    },
    '& h1': {
      fontSize: '120px',
      fontWeight: '500',
      color: '#00bcb5',
      letterSpacing: '-4px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '60px',
      },
    },
    '& h3': {
      fontSize: '20px',
      fontWeight: '500',
      color: '#333645',
      lineHeight: '1.5',
      [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
      },
    },
  },
})

class NetworkIssue extends React.Component {
  render() {
    const { classes } = this.props
    return (
      <div className={classes.root}>
        <Grid container>
          <Grid item xs={12}>
            <MenuBar withSearchBox />
          </Grid>
          <Grid item xs={12}>
            <div className={classes.pageNotFound}>
              <div>
                <img src={caveman} alt={'caveman'} />
              </div>
              <div className={classes.errorMessage}>
                <Typography variant="display2">404</Typography>
                <Typography variant="subheading">We can’t seem to find the page you’re looking for.</Typography>
              </div>
            </div>
          </Grid>
          <Grid item xs={12}>
            <Footer />
          </Grid>
        </Grid>
        <FlashMessage />
      </div>
    )
  }
}
export default withStyles(styles)(NetworkIssue)



// WEBPACK FOOTER //
// ./src/components/NetworkIssue.js